export default {
  AvailableStartTime: 'شروع اعتبار',
  AvailableStartTimeMin: 'شروع اعتبار از',
  AvailableStartTimeMax: 'شروع اعتبار تا',
  AvailableExpireTime: 'پایان اعتبار',
  AvailableExpireTimeMin: 'پایان اعتبار از',
  AvailableExpireTimeMax: 'پایان اعتبار تا',
  CashAmount: 'اعتبار نقدی',
  CashAmountMin: 'اعتبار نقدی از',
  CashAmountMax: 'اعتبار نقدی تا',
  CommandNumber: 'شماره دستور',
  CommandTime: 'تاریخ دستور',
  CommandTimeMin: 'تاریخ دستور از',
  CommandTimeMax: 'تاریخ دستور تا',
  Enabled: 'فعال',
  GiftAmount: 'اعتبار هدیه',
  GiftAmountMin: 'اعتبار هدیه از',
  GiftAmountMax: 'اعتبار هدیه تا',
  GiftCards: 'کارت هدیه',
  MaximumUse: 'حداکثر تعداد قابل استفاده',
  MaximumUseMin: 'حداکثر تعداد قابل استفاده از',
  MaximumUseMax: 'حداکثر تعداد قابل استفاده تا',
  Organization: 'سازمان',
  Title: 'عنوان',
  Pin: 'پین',
  PinLength: 'طول پین',
  Quantity: 'تعداد',
  ShowAndroid: 'نمایش در اندروید',
  ShowIOS: 'نمایش در ios',
  ShowWeb: 'نمایش در وب',
  ShowWebService: 'نمایش در وب سرویس',
  SortOrder: 'ترتیب نمایش',
  ShowOn: 'نمایش در',
  Slug: 'Slug',
  Used: 'استفاده شده',
  giftCardType: 'نوع کارت هدیه',
  giftCards: 'کارت های هدیه',

  availableStartTime: 'شروع اعتبار',
  availableExpireTime: 'پایان اعتبار',
  pinLength: 'طول پین'
}
